/** Persisted keys in user_tutorial_seen — hide Battle Overview mode stickers after first entry. */
export const BATTLE_OVERVIEW_MODE_STICKER_KEYS = {
  engageEnemy: 'battle_overview_mode_engage_enemy',
  train: 'battle_overview_mode_train',
  rejoin: 'battle_overview_mode_rejoin',
  blackOps: 'battle_overview_mode_black_ops',
  warEffort: 'battle_overview_mode_war_effort',
  anthology: 'battle_overview_mode_anthology',
  provingGrounds: 'battle_overview_mode_proving_grounds',
  dispatchAsset: 'battle_overview_mode_dispatch_asset',
  exploreUnknown: 'battle_overview_mode_explore_unknown',
};

export const BATTLE_OVERVIEW_MODE_STICKER_KEY_LIST = Object.values(BATTLE_OVERVIEW_MODE_STICKER_KEYS);
